// Formatting and error helpers shared by the administration pages of scheduled jobs
// (authority update, ISSN register harvest, Aleph title sync, Solr).
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var pad = function (n) { return n.toString().padStart(2, "0"); };
/** ISO instant -> "15.10.2026 14:05" in the browser's zone; "-" when missing or invalid. */
export var formatDateTime = function (iso) {
    if (!iso)
        return "-";
    var date = new Date(iso);
    if (Number.isNaN(date.getTime()))
        return "-";
    return "".concat(pad(date.getDate()), ".").concat(pad(date.getMonth() + 1), ".").concat(date.getFullYear(), " ").concat(pad(date.getHours()), ":").concat(pad(date.getMinutes()));
};
/** Milliseconds -> "1 h 2 min 5 s" / "2 min 5 s" / "5 s"; "-" when missing. */
export var formatDuration = function (ms) {
    if (ms == null || Number.isNaN(ms))
        return "-";
    var totalSeconds = Math.max(0, Math.round(ms / 1000));
    var hours = Math.floor(totalSeconds / 3600);
    var minutes = Math.floor((totalSeconds % 3600) / 60);
    var seconds = totalSeconds % 60;
    if (hours > 0)
        return "".concat(hours, " h ").concat(minutes, " min ").concat(seconds, " s");
    return minutes > 0 ? "".concat(minutes, " min ").concat(seconds, " s") : "".concat(seconds, " s");
};
/** Time elapsed from an ISO instant until `now` (ms); null when the start is missing or invalid. */
export var elapsedMs = function (startedAtIso, now) {
    if (!startedAtIso)
        return null;
    var started = new Date(startedAtIso).getTime();
    return Number.isNaN(started) ? null : Math.max(0, now - started);
};
// Instant ISO ("2026-08-01T00:00:00Z") <-> date input value ("2026-08-01")
export var toDateInputValue = function (iso) {
    return iso ? iso.slice(0, 10) : "";
};
export var fromDateInputValue = function (value) {
    return value ? "".concat(value, "T00:00:00Z") : null;
};
/** The readable message of a failed ky request: problem "detail" or the first FOLIO error message. */
export var extractErrorMessage = function (err) { return __awaiter(void 0, void 0, void 0, function () {
    var response, problem, firstError, _a;
    var _b, _c;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                response = err.response;
                if (!response)
                    return [2 /*return*/, null];
                _d.label = 1;
            case 1:
                _d.trys.push([1, 3, , 4]);
                return [4 /*yield*/, response.clone().json()];
            case 2:
                problem = _d.sent();
                if (typeof (problem === null || problem === void 0 ? void 0 : problem.detail) === "string")
                    return [2 /*return*/, problem.detail];
                firstError = (_c = (_b = problem === null || problem === void 0 ? void 0 : problem.errors) === null || _b === void 0 ? void 0 : _b[0]) === null || _c === void 0 ? void 0 : _c.message;
                return [2 /*return*/, typeof firstError === "string" ? firstError : null];
            case 3:
                _a = _d.sent();
                return [2 /*return*/, null];
            case 4: return [2 /*return*/];
        }
    });
}); };
/** Whether a failed ky request was answered with the given HTTP status. */
export var hasHttpStatus = function (err, status) { var _a; return ((_a = err.response) === null || _a === void 0 ? void 0 : _a.status) === status; };
